// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import {
  call, put, takeEvery
} from 'redux-saga/effects';

import * as types from './actionTypes';
import * as vouchersDetailsAction from './actions';
import { getVoucherDetailsService } from './service';


function* getVoucherDetailsSaga({ payload }) {
  yield put(vouchersDetailsAction.startLoader());

  const response = yield call(getVoucherDetailsService, payload);
  if (response.ok) {
    yield put(vouchersDetailsAction.getVouchersSuccess(response.body));
  }

  yield put(vouchersDetailsAction.stopLoader());
}

const voucherDetailsSagas = [
  takeEvery(types.VOUCHER_DETAILS_GET_VOUCHER, getVoucherDetailsSaga),
];

export default voucherDetailsSagas;
